/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import React from 'react';

// Updated type to match Backend expectations
type ColumnKeys =
  | 'name'
  | 'category'
  | 'hts_code'
  | 'country_of_origin'
  | 'manufacturer'
  | 'vendor'
  | 'status_flag'
  | 'base_duty_rate'
  | 'additional_duty_rate'
  | 'fees'
  | 'total_cost'
  | 'compliance_score'
  | 'product_value';

interface IProductColumnsProps {
  isSelectedItems?: boolean;
  handleCheckboxClick?: () => void;
  showFilters: boolean;
  sortData: (key: string) => void;
  sortConfig: { key: string; direction: string };
}

const ProductColumns: React.FC<IProductColumnsProps> = ({
  isSelectedItems,
  handleCheckboxClick,
  sortData,
  sortConfig,
}) => {
  const getSortIcon = (key: ColumnKeys) => {
    if (sortConfig.key !== key) {
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='16'
          height='16'
          viewBox='0 0 16 16'
          fill='none'
        >
          <path
            d='M8 4V12M8 4L4 8M8 4L12 8'
            stroke='var(--text-classify)'
            strokeOpacity='0.5'
            strokeWidth='1.33'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      );
    }
    if (sortConfig.direction === 'asc') {
      return (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='16'
          height='16'
          viewBox='0 0 16 16'
          fill='none'
        >
          <path
            d='M8 12.6666V3.33331M8 3.33331L3.33333 7.99998M8 3.33331L12.6667 7.99998'
            stroke='var(--text-classify)'
            strokeWidth='1.33'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      );
    }
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
      >
        <path
          d='M8 3.33331V12.6666M8 12.6666L3.33333 7.99998M8 12.6666L12.6667 7.99998'
          stroke='var(--text-classify)'
          strokeWidth='1.33'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    );
  };

  const CheckboxIcon = () =>
    isSelectedItems ? (
      <div className='full-list-filters-cont-row-icon-item'>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='12'
          height='12'
          viewBox='0 0 12 12'
          fill='none'
        >
          <path
            d='M10 3L4.5 8.5L2 6'
            stroke='var(--text-primary)'
            strokeWidth='1.6666'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      </div>
    ) : (
      <div className='full-list-filters-cont-row-icon-item-unselected'></div>
    );

  return (
    <div className='screening-results-columns'>
      <div
        className='screening-table-placeholder-column'
        style={{ borderTopLeftRadius: 'var(--radius-xl, 12px)', width: '48px' }}
      >
        <div
          className='screening-results-row-default-cell-inner'
          onClick={handleCheckboxClick}
        >
          <CheckboxIcon />
        </div>
      </div>
      <div className='screening-table-title-column'>
        <div className='screening-table-title-column-inner'>
          <div
            className='screening-table-column-text'
            onClick={() => sortData('name')}
          >
            Item {getSortIcon('name')}
          </div>
        </div>
      </div>
      <div className='screening-table-title-column'>
        <div
          className='screening-table-title-column-inner'
          onClick={() => sortData('hts_code')}
        >
          <div className='screening-table-column-text'>
            HTS Code {getSortIcon('hts_code')}
          </div>
        </div>
      </div>
      <div className='screening-table-title-column'>
        <div
          className='screening-table-title-column-inner'
          onClick={() => sortData('country_of_origin')}
        >
          <div className='screening-table-column-text'>
            Country {getSortIcon('country_of_origin')}
          </div>
        </div>
      </div>
      <div className='screening-table-title-column'>
        <div className='screening-table-title-column-inner'>
          <div
            className='screening-table-column-text'
            onClick={() => sortData('product_value')}
          >
            Product Value {getSortIcon('product_value')}
          </div>
        </div>
      </div>
      <div className='screening-table-title-column'>
        <div className='screening-table-title-column-inner'>
          <div className='screening-table-column-text'>Base Tariff/Duty</div>
        </div>
      </div>
      <div className='screening-table-title-column'>
        <div className='screening-table-title-column-inner'>
          <div className='screening-table-column-text'>
            Additional Tariff/Duty
          </div>
        </div>
      </div>
      <div className='screening-table-title-column'>
        <div className='screening-table-title-column-inner'>
          <div
            className='screening-table-column-text'
            onClick={() => sortData('compliance_score')}
          >
            Compliance Score {getSortIcon('compliance_score')}
          </div>
        </div>
      </div>
      <div className='screening-table-title-column'>
        <div className='screening-table-title-column-inner'>
          <div
            className='screening-table-column-text'
            onClick={() => sortData('compliance_score')}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default ProductColumns;
